import { useTenant } from "../context/TenantContext";
import { getCurrentDomainTitle, getCurrentHostname } from "../config/tenantConfig";


export const useTenantConfig = () => {
    const config = useTenant();
    return {
        // Tüm config
        config,

        // Kısa erişimler
        tenantId: config.tenantId,
        tenantName: config.tenantName,
        siteName: config.siteName,
        siteSlogan: config.siteSlogan,
        logo: config.logo,
        colors: config.colors,
        headerColors: config.headerColors,
        contact: config.contact,
        social: config.social,
        meta: config.meta,
        features: config.features,
        homePage: config.homePage,
        pricingPage: config.pricingPage,
        productsPage: config.productsPage,
        aboutPage: config.aboutPage,
        iletisimPage: config.iletisimPage,
        applyPage: config.applyPage,
        eImzaBasvuruPage: config.eImzaBasvuruPage,
        signInPage: config.signInPage,
        widget_video_url: config.widget_video_url,
        siteUrl: config.siteUrl,

        // Domain ve Date bilgisi
        currentDomain: getCurrentDomainTitle(),
        currentHostName:getCurrentHostname(),
        yearDate: String(new Date().getFullYear()),

        // Yardımcı fonksiyonlar
        isRonesans: config.tenantId === "ronesans",
        isUcuzimza: config.tenantId === "ucuzimza",

        // Feature check
        hasFeature: (feature) => config.features[feature] === true,
    };
};
